export default __webpack_public_path__ + "svg/calendar/2027/0/febrero.svg?54e2226a";